import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7bf690b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "all-scan-cntr" }
const _hoisted_2 = { class: "tips" }
const _hoisted_3 = { class: "console-num cm-ui-mb5" }
const _hoisted_4 = { class: "console-desc" }
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    modelValue: _ctx.modalVisiable,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalVisiable) = $event)),
    "before-close": _ctx.closeModal,
    width: "470px"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.tip')), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: _ctx.scanAllTerminal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CmSvgIcon, {
          name: "views/dashboard/safe-status/loaris-trojan-remover/_images/modal_tip",
          size: 40,
          color: "var(--cm-color-primary)",
          monochrome: "",
          "aria-hidden": false,
          "aria-label": "tip"
        }),
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, _toDisplayString(_ctx.$t('safeProtectionModule.virusScanModalFullDiskLine1', { n: _ctx.count })), 1),
          _createElementVNode("li", _hoisted_4, _toDisplayString(_ctx.$t('safeProtectionModule.virusScanModalLine2')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}